import CustomLink from '@/components/custom-link/CustomLink';
import { Urls } from '@/constants/urls';
import { Text } from '@cmpsr/components';

export type TermsAndPrivacyProps = {
  buttonMessage: string;
};

export default function TermsAndPrivacy({ buttonMessage }: TermsAndPrivacyProps) {
  return (
    <Text variant="text-body-meta-regular" color="text-secondary">
      By clicking {buttonMessage}, you agree to our{' '}
      <CustomLink color="text-secondary" fontWeight="400" href={Urls.terms_of_service}>
        Terms of Service
      </CustomLink>{' '}
      & consent to the{' '}
      <CustomLink color="text-secondary" fontWeight="400" href={Urls.privacy_policy}>
        Privacy Policy
      </CustomLink>
    </Text>
  );
}
